import "./App.css";
import DarkEventCalendar from "./components/calendar";
import { Typography } from "antd";
import React, { useEffect, useState } from "react";

const TranslatedText = ({ greekText, englishText }) => {
  const [translatedText, setTranslatedText] = useState("");

  useEffect(() => {
    const lang = document.documentElement.lang;
    console.log(lang);
    if (lang === "el") {
      setTranslatedText(greekText);
    } else {
      setTranslatedText(englishText);
    }
  }, [greekText, englishText]);

  return <div dangerouslySetInnerHTML={{ __html: translatedText }} />;
};
function App() {
  return (
    <div className="App" style={{ padding: "40px" }}>
      <Typography.Title
        level={4}
        style={{
          "font-style": "normal",
          "font-weight": "500",
          "font-size": "32px",
          "line-height": "39px",
          fontFamily: "Helvetica Neue",
        }}
      >
        <TranslatedText
          greekText="<span lang='el'>Ημερολόγιο</span>"
          englishText="<span lang='en'>Calendar</span>"
        />
      </Typography.Title>
      <DarkEventCalendar />
     
    </div>
  );
}

export default App;
